import { render, staticRenderFns } from "./SurgeryCategories.vue?vue&type=template&id=6f199c60&scoped=true"
import script from "./SurgeryCategories.vue?vue&type=script&lang=js"
export * from "./SurgeryCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f199c60",
  null
  
)

export default component.exports